export default __webpack_public_path__ + "static/media/dse701mkii.5edcddf8.webp";